export default __webpack_public_path__ + "static/media/logo.5208c6c9.svg";